import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "@/components/marketing/SectionHeading";

const FAQS = [
  { q: "How much does press release distribution in the UAE cost?", a: "Gulf newswire distribution starts at $475. Guaranteed placements in UAE titles start from $100, with flagship names like Khaleej Times and Gulf News running from $600 to $2,655. Every price is shown before you order." },
  { q: "Which UAE publications can I get published in?", a: "Guaranteed placement options include Khaleej Times, Gulf News, Arabian Business, Entrepreneur Middle East, and MENA FN, alongside regional and global titles. Browse the full Media Network for the complete list." },
  { q: "Do you distribute in Arabic?", a: "Yes. We offer bilingual distribution with native Arabic translation, so your release reaches both English and Arabic language media." },
  { q: "What does published or refunded mean?", a: "If a guaranteed placement does not publish, you receive a full refund under our refund policy. Named pickups are confirmed in advance." },
  { q: "How fast is distribution?", a: "Newswire distribution offers same-day submission. Guaranteed placement turnarounds vary by publication and are shown on each outlet page before you order." },
];

export default function UaeFAQ() {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-canvas">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading tag="FAQ" title="Frequently Asked Questions" />
        <Accordion type="single" collapsible>
          {FAQS.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-bone hover:text-cobalt text-left font-heading text-base py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-steel text-sm leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}